var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"dashed-btn",class:{'loading': _vm.loading},style:(_vm.styles),on:{"click":function($event){return _vm.$emit('click')}}},[(_vm.loading)?_c('v-progress-circular',{attrs:{"data-testid":"dashed-btn-loader","indeterminate":"","color":"#e7e7e7"}}):_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }